import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { provideTablerIcons, TablerIconComponent } from 'angular-tabler-icons';
import {
  IconCheck,
  IconChecks,
  IconClipboardText,
  IconHeadset,
  IconHeartHandshake,
  IconMinus,
  IconSparkles,
} from 'angular-tabler-icons/icons';
import { Button } from 'primeng/button';
import { AuthFacadeService } from '../../../../domain/auth/service/auth-facade.service';

@Component({
  selector: 'app-auth-information-modal',
  templateUrl: './auth-information-modal.component.html',
  styleUrl: './auth-information-modal.component.scss',
  imports: [TranslatePipe, TablerIconComponent, Button, RouterLink],
  providers: [
    provideTablerIcons({
      IconCheck,
      IconChecks,
      IconSparkles,
      IconMinus,
      IconHeartHandshake,
      IconHeadset,
      IconClipboardText,
    }),
  ],
})
export class AuthInformationModalComponent {
  constructor(private authFacadeService: AuthFacadeService) {}

  public loginWithGoogle(): void {
    this.authFacadeService.loginWithGoogle().subscribe();
  }

  public loginWithFacebook(): void {
    this.authFacadeService.loginWithFacebook().subscribe();
  }
}
